import { useTranslation } from 'react-i18next';
import Typography from '@lib/components/Typography/Typography';
import Modal from '@lib/components/Modal/Modal';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ClipboardCopy, {
  ClipboardCopyType,
} from '@lib/components/ClipboardCopy/ClipboardCopy';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import styles from './VerifyDomainModal.module.scss';

interface VerifyDomainModalProps {
  dnsTxtRecord?: string;
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onVerify: () => void;
}

export default function VerifyDomainModal(props: VerifyDomainModalProps) {
  const { dnsTxtRecord, isOpen, loading, onClose, onVerify } = props;
  const { t } = useTranslation();

  const actions = (
    <ActionsRow
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={onClose}
        />,
        <Button
          buttonText={t('verify-domain')}
          buttonType={ButtonTypes.primaryFilled}
          disabled={loading}
          fullWidth
          leftIcon="check"
          onClick={onVerify}
        />,
      ]}
    />
  );

  return (
    <Modal
      actions={actions}
      isOpen={isOpen}
      onClose={onClose}
      title={t('verify-domain-ownership')}
    >
      <div>
        <Typography variant="body" strong className={styles.subTitle}>
          {t('dns-txt-record-instructions')}
        </Typography>
        <ClipboardCopy
          copyText={dnsTxtRecord || ''}
          type={ClipboardCopyType.CodeBlock}
        >
          {dnsTxtRecord}
        </ClipboardCopy>
        <SupportiveMessage
          color={SupportiveMessageColor.Gray}
          type={SupportiveMessageType.FilledWithLeftBorder}
          text={t('dns-changes-note')}
          className={styles.supportiveMessage}
        />
      </div>
    </Modal>
  );
}
